export default __webpack_public_path__ + "static/media/ts-9-8.36dd4aaf.svg";